import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { Customer } from 'src/shared/api';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { customersFragments } from 'src/admin-app/customers/customers.routes';

@Component({
	selector: 'rpfsa-customer-list',
	templateUrl: './customer-list.component.html',
	styleUrls: ['./customer-list.component.scss'],
})
export class CustomerListComponent implements AfterViewInit {
	private loading = new BehaviorSubject<boolean>(true);
	loading$ = this.loading.asObservable();

	@Input()
	set customers(customers: Customer[]) {
		if (customers) {
			this.loading.next(false);
			this.dataSource.data = customers;
		}
	}

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	emptyColumns = ['empty'];
	resultColumns = [
		'companyName',
		'employerIdentificationNumber',
		'billingEmail',
	];

	customersFragments = customersFragments;

	dataSource = new MatTableDataSource<Customer>([]);

	constructor(public readonly router: Router) {}

	ngAfterViewInit() {
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginator;
	}
}
